module.exports = __webpack_public_path__ + "img/home_5.45158dfa.jpg";